import getApiUrl from '@/utils/getApiUrl'
import createMeta from '@/meta/createMeta'
import { url } from '@/meta/metaConfig'
const mixin = {
  data () {
    return {
      apiPath: null,
      status: 'init',
      apiResult: null,
      componentList: null,
      meta: null,
      canonical: null,
      invalidData: false
    }
  },
  metaInfo () {
    return {
      title: this.status === 'complete' ? this.meta.title : 'Loading',
      link: [
        {
          vmid: 'canonical',
          rel: 'canonical',
          href: this.canonical
        }
      ],
      meta: this.status === 'complete' ? createMeta({
        ...this.meta,
        canonical: this.canonical
      }) : []
    }
  },
  methods: {
    getApiUrl (path) {
      return getApiUrl(path)
    },
    api: async function (path) {
      const url = this.getApiUrl(path)
      this.status = 'loading'
      this.status = 'init'
      this.invalidData = false
      this.apiResult = await this.$store.dispatch('api/getRequest', { url: url })
      if (this.apiResult.status) {
        this.onApiSuccess()
        this.status = 'complete'
      } else {
        this.status = 'error'
      }
    },
    onApiSuccess: function () {
      this.meta = this.apiResult.data.meta || null
      this.componentList = this.apiResult.data.componentList || null
      if (!(this.meta) && !this.componentList) {
        this.invalidData = true
      }
    }
  },
  computed: {
    loaderStatus: function () {
      return this.status === 'complete' ? 'complete' : this.status
    }
  },
  beforeMount () {
    this.canonical = url + this.$route.path + '/'
  }
}

export default mixin



// WEBPACK FOOTER //
// ./src/mixins/ApiMixin.js